import {NgModule} from '@angular/core';
import {SelectAllOnFocusDirective} from './select-all-on-focus.directive';

@NgModule({
    declarations: [
        SelectAllOnFocusDirective
    ],
    exports: [
        SelectAllOnFocusDirective
    ]
})
export class SelectAllOnFocusModule {}
